import { useQuery } from '@tanstack/react-query';
import { cookingSessionRequests } from '@/lib/api/requests/cooking-sessions';
import type { CookingSessionSource, ListCookingSessionsParams } from '@/types/cooking-session';
import { cookingSessionKeys } from './keys';

const POLL_INTERVAL = 10_000;

interface QueryOptions {
  enabled?: boolean;
}

export function useCookingSessions(params?: ListCookingSessionsParams, options?: QueryOptions) {
  return useQuery({
    queryKey: cookingSessionKeys.list(params),
    queryFn: () => cookingSessionRequests.list(params),
    enabled: options?.enabled,
    refetchInterval: POLL_INTERVAL,
  });
}

export function useCookingSessionStats(
  params?: { locationId?: number; source?: CookingSessionSource },
  options?: QueryOptions,
) {
  return useQuery({
    queryKey: cookingSessionKeys.stats(params),
    queryFn: () => cookingSessionRequests.stats(params),
    enabled: options?.enabled,
    refetchInterval: POLL_INTERVAL,
  });
}

export function useCookingSessionCapacity(
  params?: { locationId?: number; includeCookingNow?: boolean; chefs?: number; windowMinutes?: number; source?: CookingSessionSource },
  options?: QueryOptions,
) {
  return useQuery({
    queryKey: cookingSessionKeys.capacity(params),
    queryFn: () => cookingSessionRequests.capacity(params),
    enabled: options?.enabled,
    refetchInterval: POLL_INTERVAL,
  });
}
